import {
  PlusCircle,
  FunnelSimple,
  Bank,
  Trash,
  Printer,
  Article,
  CurrencyDollarSimple,
  Export,
  X,
  XCircle,
  UploadSimple,
  Eye,
  EyeSlash,
  ArrowCircleLeft,
  ArrowCircleRight,
  PencilSimple,
  ShieldCheck,
  Users,
  ArrowsCounterClockwise,
  File,
  CaretDown,
  CaretUp,
  ArrowClockwise,
  Download,
  SignIn,
  Wallet,
  GoogleLogo,
  ArrowRight,
  HandArrowUp,
  HandArrowDown,
  PiggyBank,
  ArrowCircleDown,
  House,
  Receipt,
  Copy,
  ArrowCircleUp,
  DotsThree,
  AddressBook,
  CheckCircle,
  CopySimple,
  Lock,
  CaretLeft,
  Play,
  CaretRight,
  ArrowBendDoubleUpRight,
  ArrowBendUpRight,
  ArrowsLeftRight,
} from '@phosphor-icons/react'

export const Icons = {
  PlusCircle,
  FunnelSimple,
  Bank,
  Trash,
  Printer,
  Article,
  CurrencyDollarSimple,
  Export,
  X,
  XCircle,
  UploadSimple,
  Eye,
  EyeSlash,
  ArrowCircleLeft,
  ArrowCircleRight,
  PencilSimple,
  ShieldCheck,
  Users,
  ArrowsCounterClockwise,
  File,
  CaretDown,
  CaretUp,
  ArrowClockwise,
  Download,
  SignIn,
  Wallet,
  GoogleLogo,
  ArrowRight,
  HandArrowUp,
  HandArrowDown,
  PiggyBank,
  ArrowCircleUp,
  ArrowCircleDown,
  House,
  Receipt,
  Copy,
  DotsThree,
  AddressBook,
  CheckCircle,
  CopySimple,
  Lock,
  CaretLeft,
  Play,
  CaretRight,
  ArrowBendDoubleUpRight,
  ArrowBendUpRight,
  ArrowsLeftRight,
}
